import React, { useState, useRef, useEffect } from "react";
import "../ChatBox/ChatBox.scss";
import { PrimaryButton } from "../AllButtons/AllButtons";
import { useNavigate } from 'react-router-dom';
import ReceiveChatIcon from "../../assets/images/vactor/chat-ai-icon.svg";
import SendChatUser from "../../assets/images/vactor/Avatar1.svg";
import ChatBotIcon from "../../assets/images/vactor/chat-bot-icon.svg";
import StarIcon from "../../assets/images/vactor/star-suggetion.svg";
import ImageIcon from "../../assets/images/vactor/gallery-fill.svg";
import VoiceIcon from "../../assets/images/vactor/voice-icon.svg";
import TestImage from "../../assets/images/banner/test-user.jpg";
import { Button } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../Store/store";
import { getSelectTopic, startOrContinueChat } from "../../Services/chatbox.service";
import { getConversation } from "../../Services/chatbox.service";
import { RootState } from "../../Store/store";
import LoadingDots from "../Loader/LoadingDots/LoadingDots";
import { flushSync } from "react-dom";
import { reduceToken } from "../../Slice/userSlice";
import UpgradeDialog from "../UpgradeDialog/UpgradeDialog";
import { MathJaxContext, MathJax } from "better-react-mathjax";
import { getUserDetails } from "../../Services/profile.service";
import TopicList from "../TopicList/TopicList";
import ConfirmTopic from "../ConfirmTopic/ConfirmTopic";
import { chatReducers } from "../../Slice/chatBoxSlice";
import { openSnackbar } from "../../Slice/snackbarSlice";
import { resolveAssetUrl } from "../../Utils/url";
import { CloseIcon, DownloadIcon } from "../Icons/Icons";
import MathRenderer from "../CommonElements/MathRenderer";

// interface Topic {
//   title: string;
//   description: string;
// }
interface ConfirmDetails {
  conversation_id: string;
  topic: string;
  topic_description: string;
  subject: string;
}
interface AiResponseImage {
  url: string;
  source?: string;
  license?: string;
  attribution?: string;
  description?: string;
}

interface AiResponseQuestion {
  question: string;
  response: string;
  images: AiResponseImage[];
}

interface Message {
  id: any;
  text: string;
  sender: "user" | "bot";
  isWelcome?: boolean;
  showImage?: boolean;
  imageUrl?: string | null;
  aiImages?: AiResponseImage[];
  message_type?: "text" | "topic";
  topic?: any
  subject?: string
  multiple_questions?: boolean;
  questions?: AiResponseQuestion[];
}

const mapAiResponseToBotMessage = (
  aiResponse: { response: string; images?: AiResponseImage[]; multiple_questions?: boolean; questions?: AiResponseQuestion[] },
  overrides: Partial<Message> & { id: string }
): Message => ({
  text: aiResponse.response,
  sender: "bot",
  imageUrl: null,
  aiImages: aiResponse.images?.length ? aiResponse.images : undefined,
  multiple_questions: aiResponse.multiple_questions,
  questions: aiResponse.questions?.length ? aiResponse.questions : undefined,
  ...overrides,
});

interface ChatBoxProps {
  conversationId: string | null;
  startChat: any;
  handleConversationSelect: (conversationId: string) => void;
  setToggleTrySuggestion: React.Dispatch<React.SetStateAction<boolean>>;
  setSuggestionBox: (boolean: boolean) => void
  suggestionBox: boolean
}

const ALLOWED_IMAGE_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/gif",
  "image/webp",
];
const MAX_IMAGE_SIZE_BYTES = 5 * 1024 * 1024;

const INVALID_IMAGE_MESSAGE = "Please upload a valid image. Allowed: JPG, JPEG, PNG, GIF, WEBP.";
const IMAGE_SIZE_MESSAGE = "Image should not exceed more than 5MB.";

const ChatBox: React.FC<ChatBoxProps> = ({
  conversationId: propConversationId,
  startChat,
  handleConversationSelect,
  setToggleTrySuggestion,
  setSuggestionBox,
  suggestionBox
}) => {
  const user = useAppSelector((state) => state.user);
  const userForImage = useAppSelector((state) => state.user.user);
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const [UserImage, setUserImage] = useState<string>(
    userForImage?.profile_image
      ? resolveAssetUrl(userForImage.profile_image)
      : SendChatUser
  );

  useEffect(() => {
    if (userForImage && userForImage.profile_image) {
      setUserImage(resolveAssetUrl(userForImage.profile_image));
    } else if (userForImage) {
      setUserImage(SendChatUser);
    }
  }, [userForImage]);

  const { loading } = useAppSelector((state: RootState) => state.chatai);
  const [messages, setMessages] = useState<Message[]>([
    {
      id: "1",
      text: "Hello! I'm your YULI. How can I assist you today ?",
      sender: "bot",
      isWelcome: true,
      showImage: true,
    },
  ]);

  const [inputValue, setInputValue] = useState("");
  const [showWelcome, setShowWelcome] = useState(true);
  const [subjectId, setSubjectId] = useState(5);
  const [conversationId, setConversationId] = useState("");
  const messagesEndRef = useRef<HTMLDivElement>(null);
  const lastUserMessageRef = useRef<HTMLDivElement>(null);
  const chatContainerRef = useRef<HTMLDivElement>(null);
  const confirmSectionRef = useRef<HTMLDivElement>(null);
  const prevConversationIdRef = useRef<string | null>(null);
  const [shouldAutoScroll, setShouldAutoScroll] = useState(true);
  const [isProcessing, setIsProcessing] = useState(loading);
  const [imagePreview, setImagePreview] = useState<string | null>(null);
  const [selectedImage, setSelectedImage] = useState<File | null>(null);
  const [showTopic, setShowTopic] = useState<boolean>(false);
  const [chatDisable, setChatDisable] = useState<boolean>(false);
  const [previewImageUrl, setPreviewImageUrl] = useState<string | null>(null);
  const [alreadySubmitted, setAlreadySubmitted] = useState<boolean>(false);

  const handleDownloadImage = async (url: string) => {
    try {
      const response = await fetch(url, { cache: "no-store" });
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = "image.png";
      link.click();
      URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error(err);
    }
  };

  const [confirmDetails, setConfirmDetails] = useState<ConfirmDetails | null>(null);

  const isConfirm = useAppSelector(state => state.chatai.isConfirm);

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const fetchIdRef = useRef(0);
  const handleScroll = () => {
    const container = chatContainerRef.current;
    if (container) {
      const isAtBottom =
        Math.abs(container.scrollHeight - container.scrollTop - container.clientHeight) < 100; // threshold
      setShouldAutoScroll(isAtBottom);
    }
  };

  useEffect(() => {
    const fetchUserDetails = async () => {
      await dispatch(getUserDetails(user.uid));
      //console.info("FRESH STATE IS IT?",user.user);
      // if (user.user.is_paid === true && user.user.test_given === false) {
      //   setShowPersonalizeDialog(true);
      // } else {
      //   setShowPersonalizeDialog(false);
      // }
    };

    fetchUserDetails();
  }, []);

  useEffect(() => {
    // console.log("Messages updated:", messages);
    if (shouldAutoScroll) {
      // Check if this is a switch to an existing conversation with history
      const isSwitchingToExistingHistory = prevConversationIdRef.current !== conversationId && messages.length > 3;

      if (isSwitchingToExistingHistory) {
        // Switch to history: Scroll to total bottom
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
      } else if (lastUserMessageRef.current) {
        // Same conversation or first message of new chat: Scroll to sticky question
        lastUserMessageRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
      }
    }
    prevConversationIdRef.current = conversationId;
    setConfirmDetails(null);
    setChatDisable(false);
  }, [messages, conversationId]);

  const scrollToTop = () => {
    if (lastUserMessageRef.current) {
      lastUserMessageRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const scrollToConfirmSection = () => {
    confirmSectionRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const showImageValidationError = () => {
    dispatch(
      openSnackbar({
        message: INVALID_IMAGE_MESSAGE,
        severity: "warning",
      })
    );
  };

  const showImageSizeError = () => {
    dispatch(
      openSnackbar({
        message: IMAGE_SIZE_MESSAGE,
        severity: "warning",
      })
    );
  };

  const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      if (!ALLOWED_IMAGE_TYPES.includes(file.type)) {
        removeImage();
        showImageValidationError();
        e.target.value = "";
        return;
      }

      if (file.size > MAX_IMAGE_SIZE_BYTES) {
        removeImage();
        showImageSizeError();
        e.target.value = "";
        return;
      }

      setSelectedImage(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  const removeImage = () => {
    setSelectedImage(null);
    setImagePreview(null);
  };

  const cardSelect = async (conversationId: string, topicTitle: string, description: string, subject?: string) => {
    setChatDisable(true);
    if (conversationId && topicTitle) {
      setIsProcessing(true);
      await dispatch(getSelectTopic({ conversationId, topicTitle, description, subject: subject ?? "" }))
        .unwrap()
        .then((response) => {
          if (response?.status) {
            const updatedData = {
              ...response?.data,
              // description: description,
              // subject:subject       
            };
            setConfirmDetails(updatedData);
            setAlreadySubmitted(response?.data.already_submitted);
            setTimeout(scrollToConfirmSection, 100);
          }
        })
        .catch((error) => {
          console.error("Error fetching selected topic", error);
        })
        .finally(() => {
          setIsProcessing(false);
        });
    }
  };

  const handleSendMessage = async () => {
    const Language = localStorage.getItem('browserLanguage')
    setSuggestionBox(false);
    setShouldAutoScroll(true);
    const formattedInput = inputValue.replace(/\s+/g, " ").trim();
    const previousMessages = [...messages];
    const previousShowWelcome = showWelcome;
    const previousPreview = imagePreview;
    let requestSucceeded = false;

    if (!formattedInput && !selectedImage) {
      return;
    }

    if (selectedImage && !ALLOWED_IMAGE_TYPES.includes(selectedImage.type)) {
      removeImage();
      showImageValidationError();
      return;
    }

    const newUserMessage: Message = {
      id: Date.now().toString(),
      text: formattedInput || "",
      sender: "user",
      imageUrl: imagePreview || null,
    };

    setMessages((prev) => [...prev, newUserMessage]);
    setInputValue("");
    setShowWelcome(false);
    setIsProcessing(true);
    setImagePreview(null);
    const updatedMessages = [...messages, newUserMessage];

    const requestBody = {
      user_id: user?.uid,
      prompt: formattedInput || "",
      subject_id: subjectId,
      conversation_id: conversationId,
      image: selectedImage,
      Language,
    };

    try {
      const requestForTopics = {
        ...requestBody,
        message_type: "topic",
        topic: ""
      }

      const response: any = await dispatch(
        startOrContinueChat(
          updatedMessages.filter(
            (msg) => msg.sender === "user"
          )?.length % 5 === 0 ?
            requestForTopics :
            requestBody
        )
      ).unwrap();
      if (response?.data?.ai_response?.questions?.length) {
        const botResponse = mapAiResponseToBotMessage(response.data.ai_response, {
          id: response.data.conversation_id,
        });
        setImagePreview(null);
        localStorage.setItem("conver_ID", response.data.conversation_id);
        dispatch(reduceToken());
        dispatch(chatReducers.setIsConfirm(false));
        setConfirmDetails(null);
        setMessages((prev) => [...prev, botResponse]);
      } else {
        console.error("AI response not found");
      }
      setConversationId(response.data.conversation_id);
      setToggleTrySuggestion((prev) => !prev);

      if (updatedMessages.filter(
        (msg) => msg.sender === "user"
      )?.length % 5 === 0) {
        fetchConversation(response.data.conversation_id);
      }
      requestSucceeded = true;
    } catch (error: any) {
      setMessages(previousMessages);
      setShowWelcome(previousShowWelcome);
      setInputValue(formattedInput);
      setImagePreview(previousPreview);
      const errorMessage =
        error?.message?.includes("Invalid image file type")
          ? INVALID_IMAGE_MESSAGE
          : error?.message ||
          (typeof error === "string" ? error : "") ||
          "Something went wrong. Please try again.";
      dispatch(
        openSnackbar({
          message: errorMessage,
          severity: "error",
        })
      );
      console.error("Error fetching AI response:", error);
    } finally {
      setIsProcessing(false);
      if (requestSucceeded) {
        setSelectedImage(null);
      }
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (!isProcessing) {
        handleSendMessage();
      }
    }
  };

  const handleMPCBButtons = async (selectedSubjectId: number) => {
    flushSync(() => {
      setMessages([]);
      setShowWelcome(false);
      // setConversationId("");
      setSubjectId(selectedSubjectId);
      setShouldAutoScroll(true);
    });

    const subject =
      selectedSubjectId === 1
        ? "Mathematics"
        : selectedSubjectId === 2
          ? "Physics"
          : selectedSubjectId === 3
            ? "Biology"
            : selectedSubjectId === 4
              ? "Chemistry"
              : "";

    const userResponse: Message = {
      id: Date.now().toString(),
      // text: `Hello! Help me regarding ${subject} questions.`,
      text: subject,
      sender: "user",
    };
    setMessages((prev) => [...prev, userResponse]);
    setIsProcessing(true);

    // const botResponse: Message = {
    //   id: Date.now().toString(),
    //   text: `Hello! I'm your YULI. How can I help you today with your ${subject} questions?`,
    //   sender: "bot",
    // };

    const topicRequestBody = {
      user_id: user?.uid,
      prompt: userResponse.text,
      subject_id: selectedSubjectId,
      conversation_id: conversationId || null,
      image: selectedImage,
      // type: "static",
      // topic: JSON.stringify({"message": botResponse.text})
    };

    // try {
    //   const response: any = await dispatch(
    //     startOrContinueChat(topicRequestBody)
    //   ).unwrap();

    //   if (response?.data?.type === "static" && response?.data?.conversation_id) {
    //     setConversationId(response.data.conversation_id);
    //     handleConversationSelect(response.data.conversation_id);
    //     setToggleTrySuggestion(true);
    //   }
    // } catch (error) {
    //   console.error("Error fetching AI response:", error);
    // } finally {
    //   setIsProcessing(false);
    //   setSelectedImage(null);
    // }

    try {
      const response: any = await dispatch(
        startOrContinueChat(topicRequestBody)
      ).unwrap();
      if (response?.data?.ai_response?.questions?.length) {
        const botResponse = mapAiResponseToBotMessage(response.data.ai_response, {
          id: response.data.conversation_id,
        });
        localStorage.setItem("conver_ID", response.data.conversation_id);
        handleConversationSelect(response.data.conversation_id);
        dispatch(reduceToken());
        dispatch(chatReducers.setIsConfirm(false));
        setConfirmDetails(null);
        setMessages((prev) => [...prev, botResponse]);
      } else {
        console.error("AI response not found");
      }
      // if (response?.data?.type === "topic") {    
      //   handleConversationSelect(response.data.conversation_id);
      // }
      setConversationId(response.data.conversation_id);
      setToggleTrySuggestion((prev) => !prev);
      setIsProcessing(false);
    } catch (error) {
      console.error("Error fetching AI response:", error);
    } finally {
      setIsProcessing(false);
      setSelectedImage(null);
    }
  };

  const fetchConversation = async (currentConversationId: string) => {
    const fetchId = ++fetchIdRef.current;
    setMessages([]);
    setShowTopic(false);
    setConfirmDetails(null);
    setAlreadySubmitted(false);
    const newMessages: Message[] = [];

    if (!currentConversationId) {
      return;
    }

    try {
      setIsProcessing(true);
      const response = await dispatch(
        getConversation(currentConversationId)
      ).unwrap();

      if (fetchId !== fetchIdRef.current) {
        return;
      }
      setConversationId(currentConversationId);
      response?.data?.messages.forEach((message: any) => {
        if (!message?.type && message?.ai_response?.questions?.length) {
          newMessages.push({
            id: Date.now().toString(),
            text: message.prompt,
            sender: "user",
            imageUrl: message?.media_url ? resolveAssetUrl(message.media_url) : null,
          });
          newMessages.push(
            mapAiResponseToBotMessage(message.ai_response, {
              id: Date.now().toString(),
            })
          );
        }
        if (message.type === "topic" && message?.topic?.topics?.length > 0) {
          newMessages.push({
            id: Date.now().toString(),
            text: message.prompt,
            sender: "user",
            imageUrl: message?.media_url
              ? resolveAssetUrl(message.media_url)
              : null,
          });
          newMessages.push(
            mapAiResponseToBotMessage(message.ai_response, {
              id: Date.now().toString(),
              subject: message?.subject,
            })
          );
          newMessages.push({
            id: Date.now().toString(),
            text: "Based on your conversation, I’ve generated some topics. Would you like to view them?",
            message_type: message?.type,
            sender: "bot",
            imageUrl: null,
            topic: message.topic,
            subject: message?.subject
          });
        }
        if (message.type === "static" && message?.topic?.message) {
          newMessages.push({
            id: Date.now().toString(),
            text: message.prompt,
            sender: "user",
            imageUrl: message?.media_url ? resolveAssetUrl(message.media_url) : null,
          });
          newMessages.push({
            id: Date.now().toString(),
            text: message?.topic?.message,
            message_type: message?.type,
            sender: "bot",
            imageUrl: null,
            topic: message.topic,
          });
        }
      });

      setMessages(newMessages);

      setShowWelcome(false);
      setIsProcessing(false);
    } catch (error) {
      console.error("Failed to fetch conversation:", error);
    }
  };

  useEffect(() => {
    if (propConversationId) {
      fetchConversation(propConversationId);
    }
  }, [propConversationId, dispatch]);

  useEffect(() => {
    setShowWelcome(true);
    setConversationId("");
    setMessages([]);
    setShowTopic(false);
    setConfirmDetails(null);
    setAlreadySubmitted(false);
  }, [startChat]);

  useEffect(() => {
    handleContinueChat();
  }, [chatDisable]);

  const handleContinueChat = () => {
    if (!chatDisable && textareaRef.current) {
      textareaRef.current.focus();
    }
  };
  const lastUserMessageIndex = messages.map(m => m.sender).lastIndexOf('user');

  return (
    <>
      <div className="chatbox-wrapper">
        <div className="chating-block">
          {!showWelcome && (
            <div
              className="chating-history-block"
              key={conversationId}
              ref={chatContainerRef}
              onScroll={handleScroll}
            >
              <div className="chating-history-list" key={conversationId}>
                {messages.map((message, index) => (
                  <React.Fragment key={message.id}>
                    {(
                      message?.text ||
                      message?.topic?.topics?.length > 0 ||
                      message?.imageUrl ||
                      message?.questions?.length ||
                      message?.aiImages?.length
                    ) && (
                        <div
                          ref={index === lastUserMessageIndex ? lastUserMessageRef : null}
                          className={message.sender === "bot" ? "receive-chat" : "send-chat"}
                        >
                          {message.sender === "bot" && (
                            <div className="chat-icon">
                              <img src={ReceiveChatIcon} alt="Bot icon" />
                            </div>
                          )}

                          <div className={`${message.sender}-chat-text-block`}>
                            <div className={`${message.sender}-chat-text`}>
                              {message.sender === "user" && message.imageUrl && (
                                <img
                                  src={message.imageUrl}
                                  alt="User uploaded"
                                  className="message-image"
                                />
                              )}
                              {(message.sender === "bot" && message.message_type === "topic" && message?.topic?.topics?.length > 0) ? (
                                <>
                                  <div className="view-top-card-wrapper">
                                    <span>{message?.text}</span>
                                    <Button className="label-topics" onClick={() => setShowTopic(!showTopic)}>View Topics</Button>
                                  </div>
                                  {showTopic && (
                                    <TopicList conversationId={conversationId} topics={message.topic} onTopicClick={cardSelect} handleShowChat={() => setShowTopic(false)} confirmDetails={confirmDetails} onTopicSelected={scrollToConfirmSection} />
                                  )}
                                </>
                              ) : message.sender === "bot" ? (
                                <>
                                  {message.questions?.length ? (
                                    message.questions.map((q, qIdx) => (
                                      <div key={qIdx} style={{ marginBottom: "1rem" }}>
                                        {message.multiple_questions && (
                                          <div
                                            style={{
                                              display: "flex",
                                              alignItems: "flex-start",
                                              gap: "4px",
                                              fontWeight: 700,
                                              marginBottom: "0.25rem",
                                            }}
                                          >
                                            <span style={{ marginTop: "0.5rem" }}>{qIdx + 1}.</span>
                                            <LatexMessage text={q.question} />
                                          </div>
                                        )}
                                        {q.images && q.images.length > 0 ? (
                                          q.images.map((img, imgIdx) => (
                                            <div key={imgIdx} className="ai-image-card">
                                              <div className="ai-image-wrapper">
                                                <img
                                                  src={resolveAssetUrl(img.url)}
                                                  alt={`AI img ${imgIdx + 1}`}
                                                  className="bot-ai-image"
                                                  onClick={() => setPreviewImageUrl(resolveAssetUrl(img.url))}
                                                />
                                              </div>
                                              {img.description && (
                                                <div className="bot-ai-image-description">
                                                  <LatexMessage text={img.description} />
                                                </div>
                                              )}
                                            </div>
                                          ))
                                        ) : (
                                          <LatexMessage text={q.response} />
                                        )}
                                      </div>
                                    ))
                                  ) : (
                                    <>
                                      {(!message.aiImages || message.aiImages.length === 0) && (
                                        <LatexMessage text={message?.text} />
                                      )}

                                      {message.aiImages?.map((img, index) => (
                                        <div key={index} className="ai-image-card">
                                          <div className="ai-image-wrapper">
                                            <img
                                              src={resolveAssetUrl(img.url)}
                                              alt={`AI img ${index + 1}`}
                                              className="bot-ai-image"
                                              onClick={() => setPreviewImageUrl(resolveAssetUrl(img.url))}
                                            />
                                          </div>
                                          {img.description && (
                                            <div className="bot-ai-image-description">
                                              <LatexMessage text={img.description} />
                                            </div>
                                          )}
                                        </div>
                                      ))}
                                    </>
                                  )}
                                </>
                              ) : (
                                <>
                                  {!message.imageUrl && <span>{message?.text}</span>}
                                </>
                              )}

                              {message.showImage && (
                                <div className="chat-text-img">
                                  <img src={TestImage} alt="Illustration" />
                                </div>
                              )}
                            </div>
                            {message.isWelcome && (
                              <div className="chating-text-actions">
                                <Button>Get Started</Button>
                                <Button>View Topics</Button>
                              </div>
                            )}

                          </div>

                          {message.sender === "user" && (
                            <div className="chat-icon">
                              <img src={UserImage} alt="User icon" />
                            </div>
                          )}
                        </div>
                      )}
                  </React.Fragment>
                ))}
                <div ref={confirmSectionRef}>
                  {
                    alreadySubmitted === true ? (
                      <div className="confirmation-card mt-4">
                        <div className="confirmation-card-title">
                          Test Already Submitted
                        </div>

                        {confirmDetails && (
                          <div className="equation-block">
                            <div className="equation-block-label">
                              {confirmDetails.subject}
                            </div>

                            <div className="equation-block-title">
                              <MathRenderer text={confirmDetails.topic} />
                            </div>

                            <div className="equation-block-dsc">
                              <MathRenderer text={confirmDetails.topic_description} />
                            </div>
                          </div>
                        )}

                        <div className="continue-chat-btn">
                          You have already submitted the test for this topic. You can continue your learning journey or choose another topic to take a new assessment.
                        </div>
                      </div>
                    ) : (
                      <div className="view-top-card-wrapper">
                        {isConfirm && confirmDetails && chatDisable && (
                          <ConfirmTopic
                            confirmDetails={confirmDetails}
                            setChatDisable={setChatDisable}
                            setShowTopic={setShowTopic}
                          />
                        )}
                      </div>
                    )
                  }
                </div>
                <div ref={messagesEndRef} />
              </div>
            </div>
          )}

          {showWelcome && (
            <div className="welcome-chat-box">
              <div className="welcome-chat-icon">
                <img src={ChatBotIcon} alt="Chat bot" />
              </div>
              <div className="welcome-text">Welcome, {user?.user?.name}!</div>
              <div className="welcome-subtext">
                Welcome to YULI! How can I help you today?
              </div>
            </div>
          )}
          <div className="chat-editor-content-block">
            <div className="loading-block">
              {isProcessing && <LoadingDots />}
            </div>
            <div className="chat-editor-block">
              {imagePreview && (
                <div className="image-preview-container">
                  <img
                    src={imagePreview}
                    alt="Preview"
                    className="image-preview"
                  />
                  <button onClick={removeImage} className="remove-image-btn">
                    ×
                  </button>
                </div>
              )}
              <div className="chat-input-editor">
                <textarea
                  ref={textareaRef}
                  className="form-control text-area-editor"
                  value={inputValue}
                  onChange={(e) => setInputValue(e.target.value)}
                  onKeyPress={handleKeyPress}
                  placeholder="Start your learning journey with YULI..."
                  rows={1}
                  disabled={chatDisable}
                  style={{
                    cursor:
                      chatDisable ? "not-allowed" : "text",
                  }}
                ></textarea>
              </div>
              <div className="chat-editor-menu" style={{
                backgroundColor:
                  isProcessing ? "" : "",
                cursor:
                  chatDisable ? "not-allowed" : "auto",
              }}>
                <div className="editor-menu-block">
                  <label className="upload-img-btn" htmlFor="ImgBtn">
                    <img
                      src={ImageIcon}
                      alt="Upload image"
                      style={{
                        cursor:
                          chatDisable ? "not-allowed" : "pointer",
                      }}
                    />
                    <input
                      type="file"
                      id="ImgBtn"
                      name="image"
                      hidden
                      accept=".jpg,.jpeg,.png,.gif,.webp,image/jpeg,image/jpg,image/png,image/gif,image/webp"
                      onChange={(e) => {
                        handleImageUpload(e);
                        e.target.value = "";
                      }}
                      disabled={chatDisable}
                      style={{
                        cursor:
                          chatDisable ? "not-allowed" : "auto",
                      }}
                    />
                  </label>
                  <Button className="voice-btn d-none">
                    <img src={VoiceIcon} alt="Voice input" />
                  </Button>
                </div>
                <PrimaryButton
                  className="send-btn"
                  onClick={handleSendMessage}
                  disabled={isProcessing || chatDisable || user.tokensRemaining === 0}
                  style={{
                    backgroundColor:
                      isProcessing || user.tokensRemaining === 0 ? "gainsboro" : "",
                    cursor:
                      isProcessing || chatDisable || user.tokensRemaining === 0 ? "not-allowed" : "pointer",
                  }}
                >
                  Send{" "}
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.45938 7.9864C2.06788 7.8559 2.06413 7.64515 2.46688 7.5109L16.7821 2.7394C17.1789 2.6074 17.4061 2.8294 17.2951 3.2179L13.2046 17.5324C13.0921 17.9292 12.8634 17.9427 12.6954 17.5662L9.99988 11.5002L14.4999 5.50015L8.49988 10.0002L2.45938 7.9864V7.9864Z"
                      fill="white"
                    />
                  </svg>
                </PrimaryButton>
              </div>
            </div>

            <div
              className="chating-tools-block"
              style={
                suggestionBox &&
                  messages.filter((msg) => msg.sender === "user").length === 0
                  ? { display: "block" }
                  : { display: "none" }
              }
            >
              <div className="suggestion-block">
                <span className="suggestion-btn">
                  <img src={StarIcon} alt="" />
                  Try Suggestions
                </span>
              </div>
              <div className="tools-list">
                <Button
                  variant="text"
                  onClick={() => {
                    handleMPCBButtons(1);
                    setSuggestionBox(false);
                  }}
                >
                  Math
                </Button>

                <Button
                  variant="text"
                  onClick={() => {
                    handleMPCBButtons(2);
                    setSuggestionBox(false);
                  }}
                >
                  Physics
                </Button>
                <Button
                  variant="text"
                  onClick={() => {
                    handleMPCBButtons(4);
                    setSuggestionBox(false);
                  }}
                >
                  Chemistry
                </Button>
                <Button
                  variant="text"
                  onClick={() => {
                    handleMPCBButtons(3);
                    setSuggestionBox(false);
                  }}
                >
                  Biology
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {previewImageUrl && (
        <div
          className="image-lightbox-overlay"
          onClick={() => setPreviewImageUrl(null)}
        >
          <div
            className="image-lightbox-content"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="image-lightbox-actions">
              <button
                className="image-lightbox-download"
                onClick={() => handleDownloadImage(previewImageUrl!)}
                title="Download image"
              >
                <DownloadIcon />
              </button>
              <button
                className="image-lightbox-close"
                onClick={() => setPreviewImageUrl(null)}
                title="Close"
              >
                <CloseIcon />
              </button>
            </div>
            <img src={previewImageUrl} alt="Preview" />
          </div>
        </div>
      )}
      {user.tokensRemaining === 0 && <UpgradeDialog></UpgradeDialog>}
      {/* {showPersonalizeDialog  && <PaymentSuccess open={showPersonalizeDialog}  onClose={() => {setShowPersonalizeDialog(false);}} />}    */}
    </>
  );
};

export const LatexMessage = ({ text }: { text: string }) => {
  const mathJaxConfig = {
    loader: { load: ["input/tex", "output/chtml"] },
    tex: {
      inlineMath: [
        ["$", "$"],
        ["\\(", "\\)"],
      ],
      displayMath: [
        ["$$", "$$"],
        ["\\[", "\\]"],
      ],
      processEscapes: true,
    },
    startup: {
      typeset: true,
    },
    options: {
      enableMenu: false,
    },
  };

  const renderContent = () => {
    const lines = text?.split("\n");

    let result = [];
    let i = 0;

    while (i < lines?.length) {
      if (lines[i].trim() === "") {
        result.push(<br key={`br-${i}`} />);
        i++;
        continue;
      }

      if (lines[i].trim() === "\\[") {
        let mathContent = [];
        let j = i + 1;

        while (j < lines.length && lines[j].trim() !== "\\]") {
          mathContent.push(lines[j]);
          j++;
        }

        if (j < lines.length) {
          const displayMath = `\\[${mathContent.join("\n")}\\]`;
          result.push(
            <div
              key={`display-math-${i}`}
              style={{ margin: "1rem 0", display: "block" }}
            >
              <MathJax>{displayMath}</MathJax>
            </div>
          );
          i = j + 1;
        } else {
          result.push(
            <div key={`text-${i}`} style={{ margin: "0.5rem 0" }}>
              <MathJax>{lines[i]}</MathJax>
            </div>
          );
          i++;
        }
        continue;
      }

      if (lines[i].startsWith("### ")) {
        result.push(
          <h3 key={`heading-${i}`}>{renderBoldText(lines[i].substring(4))}</h3>
        );
      } else if (lines[i].startsWith("## ")) {
        result.push(
          <h2 key={`heading-${i}`}>{renderBoldText(lines[i].substring(3))}</h2>
        );
      } else if (lines[i].startsWith("# ")) {
        result.push(
          <h1 key={`heading-${i}`}>{renderBoldText(lines[i].substring(2))}</h1>
        );
      } else if (lines[i].startsWith("#### ")) {
        result.push(
          <h4 key={`heading-${i}`}>{renderBoldText(lines[i].substring(5))}</h4>
        );
      } else if (lines[i].match(/^(\d+)\.\s*(\\\(.*\\\))/)) {
        const [, number, equation] = lines[i].match(/^(\d+)\.\s*(\\\(.*\\\))/)!;
        result.push(
          <div
            key={`num-eq-${i}`}
            style={{ margin: "0.5rem 0", display: "flex" }}
          >
            <span style={{ marginRight: "0.5rem" }}>{number}.</span>
            <MathJax style={{ display: "inline" }}>{equation}</MathJax>
          </div>
        );
      } else {
        const containsLatex =
          lines[i].includes("$") ||
          lines[i].includes("\\(") ||
          lines[i].includes("\\)") ||
          lines[i].includes("\\[") ||
          lines[i].includes("\\]");

        if (containsLatex) {
          result.push(
            <div key={`text-${i}`} style={{ margin: "0.5rem 0" }}>
              <MathJax>{renderBoldText(lines[i])}</MathJax>
            </div>
          );
        } else {
          result.push(
            <div key={`text-${i}`} style={{ margin: "0.5rem 0" }}>
              {renderBoldText(lines[i])}
            </div>
          );
        }
      }

      i++;
    }

    return result;
  };

  const renderBoldText = (text: string) => {
    const boldParts = text.split(/(\*\*.*?\*\*)/g);
    return boldParts.map((part, index) => {
      if (part.startsWith("**") && part.endsWith("**")) {
        return (
          <strong key={`b-${index}`}>
            {part.slice(2, -2)}
          </strong>
        );
      }

      const linkRegex = /<a\s+href="([^"]+)"[^>]*>(.*?)<\/a>/g;

      const segments: React.ReactNode[] = [];
      let lastIndex = 0;
      let match;

      linkRegex.lastIndex = 0;

      while ((match = linkRegex.exec(part)) !== null) {
        const [full, href, label] = match;

        if (match.index > lastIndex) {
          segments.push(
            <span key={`t-${index}-${lastIndex}`}>
              {part.substring(lastIndex, match.index)}
            </span>
          );
        }

        segments.push(
          <a
            key={`l-${index}-${match.index}`}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#2563eb", textDecoration: "underline" }}
          >
            {label}
          </a>
        );

        lastIndex = match.index + full.length;
      }

      if (lastIndex < part.length) {
        segments.push(
          <span key={`t-${index}-end`}>
            {part.substring(lastIndex)}
          </span>
        );
      }

      return segments.length > 0 ? segments : part;
    });
  };

  return (
    <MathJaxContext config={mathJaxConfig}>
      <MathJax dynamic key={text}>
        <div className="latex-message">{renderContent()}</div>
      </MathJax>
    </MathJaxContext>
  );
};

export default ChatBox;
